import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

const LIGHT = {
  dark: false,
  colors: {
    background: '#EEF5F9', //fondo
    surface: '#FFFFFF', // cards
    'surface-bright': '#FFFFFF',
    'surface-light': '#EEEEEE',
    'surface-variant': '#424242',
    'on-surface-variant': '#EEEEEE',
    primary: '#04C1B4',
    'primary-lighten-1': '#D7FEFC',
    'primary-darken-1': '#017f73',
    secondary: '#1D4289',
    'secondary-lighten-1': '#DCE6F9',
    'secondary-darken-1': '#DCE6F9',
    accent: '#82B1FF',
    error: '#d50000',
    info: '#2196F3',
    success: '#00E676',
    warning: '#FFC107',
    amber: '#FB8C00',
  },
}

const DARK = {
  dark: true,
  colors: {
    background: '#181A1B',
    surface: '#212529',
    'surface-bright': '#2D2D2D',
    'surface-light': '#424242',
    'surface-variant': '#1E1E1E',
    'on-surface-variant': '#E0E0E0',
    primary: '#08D9C4',
    'primary-lighten-1': '#02A196',
    'primary-darken-1': '#047E6A',
    secondary: '#467BC7',
    'secondary-lighten-1': '#0042c1',
    'secondary-darken-1': '#1D428A',
    accent: '#448AFF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#00b45d',
    warning: '#FFC107',
    amber: '#e59100',
  },
}

export default createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: 'LIGHT',
    themes: { LIGHT, DARK },
  },
})
